import React, {useState} from 'react';
import {Button, Drawer, PageHeader, Space, Table, Tag} from 'antd';
import SearchAndRefresh from '../../../components/Shared/SearchAndRefresh';
import {NoticeDto, PaperApi, PaperDto, QuestionDto, QuestionType, SystemApi, UserApi, UserDto, UserRole} from '../../../scaffold';
import {useHistory} from 'react-router-dom';
import {useTabLayout} from '../../../TabLayout/TabLayoutProvider';
import {useBoolean, useInput} from 'react-hanger';
import {useOpenApiFpRequest} from '../../../Http/useOpenApiRequest';
import PaperKeywordFilter from '../../../utils/keywordFiliter/Paper';
import {useMount} from 'react-use';
import NoticeSaveForm from '../../../components/System/NoticeSaveForm';
import useQuickRouter from '../../../utils/useQuickRouter';
import moment from 'moment';

export default function ManageNoticeListPage() {
  const history = useHistory();
  const tabLayout = useTabLayout();
  const quickRouter = useQuickRouter();
  const listState = useOpenApiFpRequest(SystemApi, SystemApi.prototype.systemListAllNoticeGet);

  const keyword = useInput('');
  const displayRows = listState.data?.filter(i => PaperKeywordFilter(i, keyword.value));

  const isDialogSave = useBoolean(false);
  const [selected, setSelected] = useState<NoticeDto>();

  function refresh() {
    listState.requestSync({pi: 1, ps: 9999});
  }

  useMount(() => {
    refresh();
  });

  return (
    <div>
      <PageHeader
        title={'通知列表'}
        style={{background: 'white'}}
        extra={
          <Space>
            <Button
              type={'primary'}
              onClick={() => {
                isDialogSave.setTrue();
                setSelected(undefined);
              }}>
              添加通知
            </Button>
          </Space>
        }
      />
      <div className={'p-20'}>
        <SearchAndRefresh {...keyword.valueBind} refresh={refresh} loading={listState.loading} />
        <Table size={'small'} className={'m-t-10'} bordered dataSource={displayRows || []} rowKey={'id'} loading={listState.loading}>
          <Table.Column title={'编号'} dataIndex={'id'} width={100} />
          <Table.Column title={'通知标题'} dataIndex={'topic'} />
          <Table.Column<NoticeDto> title={'发布时间'} width={140} render={(_, item) => moment(item.publishedDate).format('YYYY-MM-DD')} />
          <Table.Column<NoticeDto>
            width={80}
            align={'center'}
            title={'是否隐藏'}
            render={(_, item) => (item.isHide ? <Tag color={'red'}>隐藏</Tag> : <Tag color={'green'}>可见</Tag>)}
          />
          <Table.Column<NoticeDto>
            title={'操作'}
            width={380}
            render={(_, item) => (
              <Space>
                <a
                  onClick={() => {
                    isDialogSave.setTrue();
                    setSelected(item);
                  }}>
                  编辑
                </a>
              </Space>
            )}
          />
        </Table>
        <Drawer width={700} title={(selected ? '编辑' : '添加') + '通知'} visible={isDialogSave.value} onClose={isDialogSave.setFalse}>
          <NoticeSaveForm
            exist={selected}
            onSuccess={() => {
              refresh();
              isDialogSave.setFalse();
            }}
          />
        </Drawer>
      </div>
    </div>
  );
}
